<template>
    <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.985 8.17414C15.985 7.6305 15.9362 7.10778 15.8456 6.60596H8.625V9.57156H12.7511C12.5733 10.5299 12.0332 11.3419 11.2212 11.8855V13.8091H13.6989C15.1486 12.4744 15.985 10.509 15.985 8.17414Z"
            fill="#4285F4"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.62502 15.6665C10.695 15.6665 12.4305 14.98 13.699 13.8091L11.2212 11.8855C10.5347 12.3455 9.65653 12.6173 8.62502 12.6173C6.6282 12.6173 4.93805 11.2687 4.33517 9.45654H1.7738V11.4429C3.03532 13.9485 5.62805 15.6665 8.62502 15.6665Z"
            fill="#34A853"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.33519 9.45658C4.18186 8.99658 4.09474 8.50522 4.09474 7.99991C4.09474 7.49461 4.18186 7.00325 4.33519 6.54325V4.55688H1.77383C1.25459 5.59188 0.958374 6.76279 0.958374 7.99991C0.958374 9.23704 1.25459 10.4079 1.77383 11.4429L4.33519 9.45658Z"
            fill="#FBBC05"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.62502 3.38249C9.75062 3.38249 10.7612 3.76931 11.5558 4.52901L13.7547 2.33007C12.427 1.09295 10.6915 0.333252 8.62502 0.333252C5.62805 0.333252 3.03532 2.05128 1.7738 4.55689L4.33517 6.54325C4.93805 4.73113 6.6282 3.38249 8.62502 3.38249Z"
            fill="#EA4335"
        />
    </svg>
</template>

<script>
export default {
    name: "GoogleLoginLogo",
};
</script>
